

export const beneficios = [
    {
        title: 'Usuarios',
        prop: 'usuario',
        type: 'number',
    },
     {
        title: 'Almacenes',
        prop: 'almacenes',
        type: 'number',
    },
     {
        title: 'Documentos',
        prop: 'documentos',
        type: 'number',
    },
     {
        title: 'Multimoneda',
        prop: 'multimoneda',
        type: 'boolean'
    },
    {
        title: 'Reportes',
        prop: 'reportes',
         type: 'number',
    },
    {
      title: 'Invetario',
      prop: 'inventario',
       type: 'boolean',
  },
        {
        title: 'Contabilidad',
        prop: 'contabilidad',
         type: 'boolean',
    },
      {
        title: 'Cuentas por cobrar y pagar',
        prop: 'cxc_cxc',
         type: 'boolean',
    }, 
     {
        title: 'Sistema de ventas (POS)',
        prop: 'pos',
         type: 'boolean',
    },
     {
        title: 'Contribuyentes especiales',
        prop: 'contribuyente_especial',
         type: 'boolean',
    },
    {
        title: 'Normativas Fiscales',
        prop: 'normativaFiscal',
        type: 'boolean',
    },
      {
        title: 'Precios',
        prop: 'normativaFiscal',
        type: 'price',
    },

      {
        title: '',
        prop: '',
        type: 'contacto',
    },


]

export const beneficios_pa = [
    {
        title: 'Usuarios',
        prop: 'usuario',
        type: 'number',
    },
     {
        title: 'Almacenes',
        prop: 'almacenes',
        type: 'number',
    },
     {
        title: 'Documentos',
        prop: 'documentos',
        type: 'number',
    },
     {
        title: 'Multimoneda',
        prop: 'multimoneda',
        type: 'boolean'
    },
    {
        title: 'Reportes',
        prop: 'reportes',
         type: 'number',
    },
    {
      title: 'Invetario',
      prop: 'inventario',
       type: 'boolean',
  },
        {
        title: 'Contabilidad',
        prop: 'contabilidad',
         type: 'boolean',
    },
      {
        title: 'Cuentas por cobrar y pagar',
        prop: 'cxc_cxc',
         type: 'boolean',
    }, 
     {
        title: 'Sistema de ventas (POS)',
        prop: 'pos',
         type: 'boolean',
    },  
      {
        title: 'Precios',
        prop: 'normativaFiscal',
        type: 'price',
    },

      {
        title: '',
        prop: '',
        type: 'contacto',
    },


]


export const planes_ve = [
    {
        title: 'Facturación Esencial',
        subTitle: 'Ideal para emprendedores y negocios pequeños',
        favorito: false,
        usuario: 1,
        almacenes : 0,
        documentos: 50,
        multimoneda: true,
        reportes: 20,
        normativaFiscal: true,
        inventario: false,
        contabilidad: false,
        cxc_cxc: false,
        pos: true,
        contribuyente_especial: false, 
        precio: 20
    },
     {
        title: 'Basico',
        subTitle: 'El punto de partida para una gestión integral',
        favorito: false,
        usuario: 1,
        almacenes : 1,
        documentos: 50,
        multimoneda: true,
        reportes: 80,
        normativaFiscal: true,
        inventario: true,
        contabilidad: false,
        cxc_cxc: true,
        pos: true,
        contribuyente_especial: false, 
        precio: 35
    },
      {
        title: 'Intermedio',
        subTitle: 'Empresas que requieren mayor control financiero',
        favorito: true,
        usuario: 3,
        almacenes : 2,
        documentos: 300,
        multimoneda: true,
        reportes: 80,
        normativaFiscal: true,
        inventario: true,
        contabilidad: false,
        cxc_cxc: true,
        pos: true,
        contribuyente_especial: false, 
        precio: 50
    },
     {
        title: 'Avanzado',
        subTitle: 'La solución para contribuyentes especiales y empresas complejas',
        favorito: false,
        usuario: 5,
        almacenes : 5,
        documentos: 1000,
        multimoneda: true,
        reportes: 100,
        normativaFiscal: true,
        inventario: true,
        contabilidad: true,
        cxc_cxc: true,
        pos: true,
        contribuyente_especial: true, 
        precio: 65
    }
]

export const planes_pa = [
    {
        title: 'Facturación Esencial',
        subTitle: 'Ideal para emprendedores y negocios pequeños',
        favorito: false,
        usuario: 1,
        almacenes : 0,
        documentos: 50,
        multimoneda: true,
        reportes: 20,
        normativaFiscal: true,
        inventario: false,
        contabilidad: false,
        cxc_cxc: false,
        pos: true, 
        precio: 15
    }, 
     {
        title: 'Avanzado',
        subTitle: 'La solución para empresas complejas',
        favorito: true,
        usuario: 5,
        almacenes : 5,
        documentos: 1000,
        multimoneda: true,
        reportes: 100,
        normativaFiscal: true,
        inventario: true,
        contabilidad: true,
        cxc_cxc: true,
        pos: true, 
        precio: 45
    }
]